import { safeJsonParse } from '../../../admin/api';

export const WORK_DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
export const PROFILE_TABS = [
  { value: 'profile', label: 'Staff Profile' },
  { value: 'session-grants', label: 'Sessions + Grants' },
];

export function parseTimeValue(value) {
  if (!value) {
    return null;
  }

  const [hours = '0', minutes = '0'] = value.split(':');
  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0, 0);
  return date;
}

export function formatTimeValue(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) {
    return '';
  }

  const hours = String(value.getHours()).padStart(2, '0');
  const minutes = String(value.getMinutes()).padStart(2, '0');
  return `${hours}:${minutes}:00`;
}

export function compareTimeValues(start, end) {
  if (!start || !end) {
    return true;
  }

  return formatTimeValue(start) < formatTimeValue(end);
}

export function buildProfileForm(profile) {
  return {
    role_code: profile?.role_code || '',
    timezone: profile?.timezone || '',
    work_days: safeJsonParse(profile?.work_days_json, []) || [],
    shift_start_time: parseTimeValue(profile?.shift_start_time),
    shift_end_time: parseTimeValue(profile?.shift_end_time),
    allow_after_hours: Boolean(profile?.allow_after_hours),
    status: profile?.status || '',
  };
}
